import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
  marginBottom: '0.75rem',
};

const NodeMonitorSection = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      <Typography paragraph>
        The Node Monitor Page enables users to input IP addresses and port numbers they want to monitor. It also offers options for managing those entries and viewing related performance metrics.
      </Typography>

      {/* Key Features */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Key Features
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1" component="p">
            <strong>User Input Form:</strong> A straightforward form for submitting IP and port combinations for monitoring.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1" component="p">
            <strong>View Button:</strong> A button attached to each list item that navigates to a graph view displaying metrics.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1" component="p">
            <strong>Delete Button:</strong> Allows users to permanently remove an IP-port entry from the monitoring list.
          </Typography>
        </li >
      </ul>
      <Typography variant="body1" color="text.secondary" >
        Note: Once deleted, entries and their associated monitoring data cannot be restored.
      </Typography>

      {/* Interaction Flow */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Interaction Flow
      </Typography>
      <ol style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1" component="p">
            Users enter IP and port in the form.
          </Typography>
        </li>
        <li style={listItemStyle}> 
          <Typography variant="body1" component="p">
            Submitted items are added to the active monitoring list.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1" component="p">
            Each item includes a View button to open detailed graphs and a Delete button to remove the entry.
          </Typography>
        </li>
      </ol>
    </Box>
  );
};

export default NodeMonitorSection;
